"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7372],{

/***/ 12740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_DetailLocalInformation; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/common/error/ErrorBoundary.tsx + 8 modules
var ErrorBoundary = __webpack_require__(17550);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(93391);
// EXTERNAL MODULE: ./public/P/images/ico/ico_spr.png
var ico_spr = __webpack_require__(99653);
var ico_spr_default = /*#__PURE__*/__webpack_require__.n(ico_spr);
;// CONCATENATED MODULE: ./components/style/detailpackage/localinformation.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-top: 60px;\n\n	table {\n		th {\n			min-width: 100px;\n		}\n	}\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: flex;\n	align-items: center;\n	justify-content: space-between;\n	margin-bottom: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	font-size: var(--basic-size);\n	color: var(--default-color);\n	> span:first-of-type {\n		margin-right: 8px;\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: inline-block;\n	width: 240px;\n	height: 37px;\n	margin-left: 10px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	display: block;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: inline-block;\n	line-height: 28px;\n	padding-left: 28px;\n	margin: 0 10px 2px 0;\n	&::before {\n		position: absolute;\n		top: 5px;\n		left: 0;\n		display: inline-block;\n		width: 18px;\n		height: 19px;\n		background: url(",
        ') no-repeat 0 -247px;\n		vertical-align: middle;\n		content: "";\n	}\n'
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-left: 5px;\n	margin-right: 5px;\n	font-size: 16px;\n	color: var(--emp-color);\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	position: relative;\n	display: inline-block;\n	line-height: 28px;\n	padding-left: 28px;\n	margin: 0 10px 2px 0;\n	vertical-align: middle;\n\n	&::before {\n		position: absolute;\n		top: 3px;\n		left: 0;\n		display: inline-block;\n		width: 18px;\n		height: 20px;\n		background: url(",
        ') no-repeat 0 -306px;\n		content: "";\n	}\n'
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n	margin-right: 5px;\n	font-size: 16px;\n	color: var(--emp-color);\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var Wrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4134af5-0"
})(_templateObject());
var TitArea = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4134af5-1"
})(_templateObject1());
var DayText = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-4134af5-2"
})(_templateObject2());
var SelectWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4134af5-3"
})(_templateObject3());
var TimeInfoWrap = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4134af5-4"
})(_templateObject4());
var TimeInfo = styled_components_browser_esm["default"].p.withConfig({
    componentId: "sc-4134af5-5"
})(_templateObject5(), (ico_spr_default()));
var TimeText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-4134af5-6"
})(_templateObject6());
var DollerInfo = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-4134af5-7"
})(_templateObject7(), (ico_spr_default()));
var DollerText = styled_components_browser_esm["default"].span.withConfig({
    componentId: "sc-4134af5-8"
})(_templateObject8());


// EXTERNAL MODULE: ./framework/ui/desktop/select/index.ts
var desktop_select = __webpack_require__(64249);
// EXTERNAL MODULE: ./framework/ui/desktop/table/index.ts + 1 modules
var table = __webpack_require__(5540);
// EXTERNAL MODULE: ./framework/ui/desktop/text/index.ts + 2 modules
var desktop_text = __webpack_require__(81499);
// EXTERNAL MODULE: ./hooks/services/queries/prdt/event/useEventLocal.ts
var useEventLocal = __webpack_require__(96487);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/product/pages/detailPackage/desktop/DetailLocalInformation.tsx











var daykor = [
    "일",
    "월",
    "화",
    "수",
    "목",
    "금",
    "토"
];
var DetailLocalInformationComponent = function(param) {
    var evCd = param.evCd;
    var ref;
    var useLocal = (0,useEventLocal/* default */.Z)(evCd);
    var local = (ref = useLocal.data) === null || ref === void 0 ? void 0 : ref.body;
    var cityInfo = (local === null || local === void 0 ? void 0 : local.cityInfo) || [];
    var exchangeInfo = (local === null || local === void 0 ? void 0 : local.exchangeInfo) || [];
    var id = (0,react.useId)();
    var ref1 = (0,react.useState)(false), showTime = ref1[0], setShowTime = ref1[1];
    var ref2 = (0,react.useState)(""), currentTime = ref2[0], setCurrentTime = ref2[1];
    var ref3 = (0,react.useState)(false), showExchange = ref3[0], setShowExchange = ref3[1];
    var ref4 = (0,react.useState)(""), currentExchange = ref4[0], setCurrentExchange = ref4[1];
    // 현재시간
    var now = (0,react.useMemo)(function() {
        if (!local) return null;
        var fullDate = dayjs_min_default()(local.nowDate);
        var date = fullDate.format("YYYY.MM.DD");
        var HHmm = fullDate.format("HH:mm");
        var dow = daykor[fullDate.day()];
        return {
            fullDate: fullDate,
            date: date,
            HHmm: HHmm,
            dow: dow
        };
    }, [
        local
    ]);
    // 현지시간
    var ref5 = (0,react.useState)({
        date: null,
        dow: "",
        HHmm: "",
        descript: ""
    }), loc = ref5[0], setLoc = ref5[1];
    // 통화/환율 데이터
    var ref6 = (0,react.useState)([]), exchange = ref6[0], setExchange = ref6[1];
    // 현지시간 수정
    var handleTimeInfo = function(city) {
        if (!now) return;
        var _timeDiff = city.timeDiff, timeDiff = _timeDiff === void 0 ? "0" : _timeDiff;
        var ref = (0,_sliced_to_array/* default */.Z)(timeDiff.split("."), 2), HhStr = ref[0], mmStr = ref[1];
        var HH = HhStr ? Number(HhStr) : 0;
        var mm = mmStr ? Number(mmStr) : 0;
        if (Number(timeDiff) < 0) mm = -Math.abs(mm);
        var descript = HH === 0 && mm === 0 ? "(우리나라와 같은 시간대 사용)" : "(한국 시간 보다 ".concat(Math.abs(HH), "시간 ").concat(mm !== 0 ? "".concat(Math.abs(mm), "분 ") : "").concat(Number(timeDiff) > 0 ? "빠름" : "느림", ")");
        var fullDate = now.fullDate.add(HH, "hour").add(mm, "minute");
        var date = fullDate.format("YYYY.MM.DD");
        var HHmm = fullDate.format("HH:mm");
        var dow = daykor[fullDate.day()];
        setLoc({
            descript: descript,
            dow: dow,
            date: date,
            HHmm: HHmm
        });
    };
    (0,react.useEffect)(function() {
        // 초기값 세팅
        if (cityInfo.length > 0) {
            var city = cityInfo[0]; // 첫번째 값
            handleTimeInfo(city);
            setCurrentTime(city.cityNm);
            setCurrentExchange(city.cityNm);
            var copyExchagne = exchangeInfo.filter(function(v) {
                return v.currCd === exchangeInfo[0].currCd;
            }); // 달러 세팅
            setExchange(copyExchagne);
        }
    }, [
        local
    ]);
    // select 콤보박스 제거 이벤트
    (0,react.useEffect)(function() {
        if (showTime || showExchange) {
            var event = function(e) {
                if (document.body.contains(e.target)) {
                    !e.target.closest("#time-".concat(CSS.escape(id))) && setShowTime(false);
                    !e.target.closest("#exchange-".concat(CSS.escape(id))) && setShowExchange(false);
                }
            };
            setTimeout(function() {
                return window.addEventListener("click", event);
            });
            return function() {
                window.removeEventListener("click", event);
            };
        }
    }, [
        showTime,
        showExchange
    ]);
    // 현지시간 셀렉트 이벤트
    var handleLocalTime = function(city) {
        handleTimeInfo(city);
        setCurrentTime(city.cityNm);
        setShowTime(!showTime);
    };
    // 통화/환율 셀렉트 이벤트
    var handleExchange = function(city) {
        var copyExchange = exchangeInfo.filter(function(v) {
            return [
                "USD",
                city.currCd
            ].includes(v.currCd);
        });
        setExchange(copyExchange);
        setCurrentExchange(city.cityNm);
        setShowExchange(!showExchange);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cityInfo.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrap, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitArea, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_text/* SubTitle */.DK, {
                            children: "현지 정보"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DayText, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "한국시간"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "".concat(now.date, " (").concat(now.dow, ") ").concat(now.HHmm)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* TableContainer */.x, {
                    background: false,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("caption", {
                            children: "현지정보 표"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("colgroup", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "10%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "10%"
                                    }
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("col", {
                                    style: {
                                        width: "80%"
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "row",
                                            children: "현지시간"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrap, {
                                                id: "time-".concat(id),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                                        onClick: function() {
                                                            return setShowTime(!showTime);
                                                        },
                                                        tabIndex: 1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                            children: currentTime
                                                        })
                                                    }),
                                                    showTime && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                                        children: cityInfo.map(function(city) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                onClick: function() {
                                                                    return handleLocalTime(city);
                                                                },
                                                                value: city.currCd,
                                                                children: city.cityNm
                                                            }, city.cityCd);
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeInfoWrap, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TimeInfo, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "".concat(loc.date, " (").concat(loc.dow, ")")
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeText, {
                                                            children: loc.HHmm
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: loc.descript
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                            scope: "row",
                                            children: "통화/환율"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectWrap, {
                                                id: "exchange-".concat(id),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectBox */.jL, {
                                                        onClick: function() {
                                                            return setShowExchange(!showExchange);
                                                        },
                                                        tabIndex: 1,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectLabel */.n5, {
                                                            children: currentExchange
                                                        })
                                                    }),
                                                    showExchange && /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_select/* SelectOptions */.PN, {
                                                        children: cityInfo.map(function(city) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                onClick: function() {
                                                                    return handleExchange(city);
                                                                },
                                                                value: city.currCd,
                                                                children: city.cityNm
                                                            }, "ex".concat(city.cityCd));
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DollerInfo, {
                                                children: exchange.map(function(ex, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                                        children: [
                                                            index === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DollerText, {
                                                                children: "1".concat(ex.exchNm, "(").concat(ex.currCd, ") = ").concat(ex.exchRat, "원")
                                                            }),
                                                            index === 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    "(",
                                                                    dayjs_min_default()(ex.exchDt).format("YYYY.MM.DD"),
                                                                    " 기준)"
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var DetailLocalInformation = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorBoundary/* default */.Z, {
        logMsg: "DetailLocalInformation Error",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DetailLocalInformationComponent, (0,_object_spread/* default */.Z)({}, props))
    });
};
/* harmony default export */ var desktop_DetailLocalInformation = (DetailLocalInformation);


/***/ }),

/***/ 73829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AO": function() { return /* binding */ ListTitle; },
/* harmony export */   "Bh": function() { return /* binding */ TextNone; },
/* harmony export */   "ER": function() { return /* binding */ Summary; },
/* harmony export */   "HC": function() { return /* binding */ ListItem; },
/* harmony export */   "Ls": function() { return /* binding */ ButtonWrap; },
/* harmony export */   "PS": function() { return /* binding */ PriceWrap; },
/* harmony export */   "aV": function() { return /* binding */ List; },
/* harmony export */   "fx": function() { return /* binding */ AditorCaution; },
/* harmony export */   "jC": function() { return /* binding */ Note; },
/* harmony export */   "n2": function() { return /* binding */ ContentTitleWrap; },
/* harmony export */   "pl": function() { return /* binding */ Thumbnail; },
/* harmony export */   "tA": function() { return /* binding */ Price; },
/* harmony export */   "wW": function() { return /* binding */ ContentTitle; },
/* harmony export */   "yk": function() { return /* binding */ ListDetail; },
/* harmony export */   "yq": function() { return /* binding */ ListContent; },
/* harmony export */   "zC": function() { return /* binding */ TextBox; },
/* harmony export */   "zw": function() { return /* binding */ MoreButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81499);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 11px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: absolute;\n	bottom: -6px;\n	right: 0;\n	display: flex;\n	justify-content: end;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 10px;\n	border-top: 1px solid var(--line-color);\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	border-bottom: 1px solid var(--line-color);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	height: 70px;\n	flex-flow: row nowrap;\n	flex-grow: 1;\n	flex-basis: 0;\n	justify-content: space-between;\n	align-items: center;\n	cursor: pointer;\n\n	",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	height: 70px;\n	align-items: center;\n	h5 {\n		padding-left: 20px;\n		font-size: var(--medium-size);\n		color: var(--emp-color);\n		flex-grow: 2;\n		",
        "\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 270px;\n	margin-left: 36px;\n	color: var(--default-color);\n	flex-shrink: 0;\n	text-align: left;\n\n	span {\n		margin-right: 10px;\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	padding: 0 20px;\n	margin-top: -5px;\n	background-color: transparent;\n\n	&:after {\n		display: block;\n		width: 10px;\n		height: 10px;\n		border-top: 1px solid var(--emp-color);\n		border-right: 1px solid var(--emp-color);\n		font-size: 0px;\n		transform: rotate(135deg);\n		content: "";\n	}\n\n	',
        "\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 0;\n	transition: height 0.5s ease;\n	opacity: 0;\n	overflow: hidden;\n\n	> div {\n		display: flex;\n		width: 100%;\n		padding: 10px 0 30px;\n	}\n	",
        "\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 190px;\n	height: 130px;\n	margin-left: 20px;\n	flex-basis: 190px;\n	flex-shrink: 0;\n	overflow: hidden;\n\n	img {\n		width: 100%;\n		height: auto;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	width: 100%;\n	margin: 0 18px 0 20px;\n\n	p {\n		line-height: 1.6;\n	}\n\n	dt {\n		color: var(--emp-color);\n	}\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	display: flex;\n	margin-top: 20px;\n	align-items: center;\n	gap: 28px;\n\n	dl {\n		display: flex;\n		gap: 8px;\n		line-height: 1;\n\n		dt {\n			position: relative;\n			padding-left: 12px;\n\n			&:before {\n				position: absolute;\n				top: 50%;\n				left: 0;\n				width: 3px;\n				height: 3px;\n				background-color: var(--bl-color);\n				transform: translateY(-50%);\n				content: "";\n			}\n		}\n	}\n'
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        '\n	margin-top: 20px;\n	line-height: 1;\n\n	span {\n		position: relative;\n		padding-left: 12px;\n		color: var(--emp-color);\n\n		&:before {\n			position: absolute;\n			top: 50%;\n			left: 0;\n			width: 3px;\n			height: 3px;\n			background-color: var(--bl-color);\n			transform: translateY(-50%);\n			content: "";\n		}\n	}\n\n	div {\n		padding: 10px 0 0 12px;\n		line-height: 1.6;\n	}\n'
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	height: 60px;\n	border-bottom: 1px solid var(--line-color);\n	align-items: center;\n	justify-content: center;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var ContentTitleWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-0"
})(_templateObject());
var ContentTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__/* .SubTitle */ .DK).withConfig({
    componentId: "sc-fb4987c2-1"
})(_templateObject1());
var AditorCaution = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-2"
})(_templateObject2());
var ButtonWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-3"
})(_templateObject3());
var List = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].ul.withConfig({
    componentId: "sc-fb4987c2-4"
})(_templateObject4());
var ListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].li.withConfig({
    componentId: "sc-fb4987c2-5"
})(_templateObject5());
var ListContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-6"
})(_templateObject6(), function(props) {
    return props.isActive && '\n        h5 {\n            \n			font-family: "PT-medium";\n        }\n    ';
});
var ListTitle = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-7"
})(_templateObject7(), (0,_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__/* .Ellipsis */ .mH)(2));
var PriceWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-8"
})(_templateObject8());
var Price = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-9"
})(_templateObject9());
var MoreButton = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].button.withConfig({
    componentId: "sc-fb4987c2-10"
})(_templateObject10(), function(props) {
    return props.isActive && '\n        margin-top: 9px;\n        \n        &:after {\n            display: block;\n            width: 10px;\n            height: 10px;\n            border-top: 1px solid var(--emp-color);\n            border-right: 1px solid var(--emp-color);\n            font-size: 0px;\n            transform: rotate(-45deg);\n            content: "";\n        }\n    ';
});
var ListDetail = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-11"
})(_templateObject11(), function(props) {
    return props.isActive && "\n		opacity: 1;\n		height: ".concat(props.contentHeight, "px;\n	");
});
var Thumbnail = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-12"
})(_templateObject12());
var TextBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-13"
})(_templateObject13());
var Summary = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-14"
})(_templateObject14());
var Note = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-15"
})(_templateObject15());
var TextNone = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-fb4987c2-16"
})(_templateObject16());



/***/ }),

/***/ 43162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I5": function() { return /* binding */ TabContent; },
/* harmony export */   "wW": function() { return /* binding */ ContentTitle; }
/* harmony export */ });
/* unused harmony exports ScrollTabList, ScrollTabItem, ScrollContent, TabListWrap */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81499);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	top: 60px;\n	display: flex;\n	width: 100%;\n	padding-top: 30px;\n	background-color: #fff;\n	z-index: 5;\n\n	li {\n		display: flex;\n		height: 50px;\n		margin-left: 1px;\n		align-items: center;\n		justify-content: center;\n		flex: 1 1 0;\n	}\n	",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	height: 100%;\n	background-color: #fff;\n	color: var(--emp-color);\n	cursor: pointer;\n	align-items: center;\n	justify-content: center;\n	outline: 1px solid var(--line-color);\n\n	",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	scroll-margin: 164px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	padding-top: 30px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}


var ScrollTabList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].ul.withConfig({
    componentId: "sc-30ef5da3-0"
})(_templateObject(), function(props) {
    return props.isFixed === false && "\n		position: static;\n	";
});
var ScrollTabItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
    componentId: "sc-30ef5da3-1"
})(_templateObject1(), function(props) {
    return props.isActive && "\n		background-color: var(--emp-color);\n		outline: 1px solid var(--emp-color);\n		color: #fff;\n	";
});
var ScrollContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-30ef5da3-2"
})(_templateObject2());
var TabListWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-30ef5da3-3"
})(_templateObject3());
var TabContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-30ef5da3-4"
})(_templateObject4());
var ContentTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__/* .SubTitle */ .DK).withConfig({
    componentId: "sc-30ef5da3-5"
})(_templateObject5());



/***/ }),

/***/ 69338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ SubTitleWrap; },
/* harmony export */   "Eq": function() { return /* binding */ Wrap; },
/* harmony export */   "KR": function() { return /* binding */ ScrollTabItem; },
/* harmony export */   "MI": function() { return /* binding */ SurchargeBox; },
/* harmony export */   "MV": function() { return /* binding */ ScrollContent; },
/* harmony export */   "Pv": function() { return /* binding */ TopNavi; },
/* harmony export */   "VY": function() { return /* binding */ Content; },
/* harmony export */   "dR": function() { return /* binding */ ScrollTabList; },
/* harmony export */   "ls": function() { return /* binding */ EditorWrap; },
/* harmony export */   "mf": function() { return /* binding */ TopNaviItem; },
/* harmony export */   "oe": function() { return /* binding */ PlayBox; },
/* harmony export */   "wG": function() { return /* binding */ ImgEditor; }
/* harmony export */ });
/* unused harmony exports DayList, DayListItem, ScheduleContent, TabContent, ContentTitle */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93391);
/* harmony import */ var _FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81499);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 60px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	scroll-margin: 60px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	top: 0;\n	display: flex;\n	width: 100%;\n	margin-left: 1px;\n	z-index: 15;\n\n	li {\n		width: 33.3333%;\n		height: 60px;\n		font-size: var(--medium-size);\n		cursor: pointer;\n		vertical-align: middle;\n		text-align: center;\n		flex: 1 1 0;\n\n		&:not(:last-child) a {\n			border-right: none;\n		}\n	}\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	height: 100%;\n	width: 100%;\n	border: 1px solid var(--line-color);\n	border-bottom-color: var(--emp-color);\n	background-color: var(--disabled-color);\n	align-items: center;\n	flex-direction: column;\n	justify-content: center;\n	box-sizing: border-box;\n	line-height: 1;\n	gap: 5px;\n	color: var(--gray-color);\n\n	",
        "\n	em {\n		font-size: var(--medium-size);\n	}\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	top: 60px;\n	display: flex;\n	width: 100%;\n	padding-top: 30px;\n	margin-left: 1px;\n	background-color: #fff;\n	z-index: 10;\n\n	li {\n		display: flex;\n		height: 50px;\n		align-items: center;\n		justify-content: center;\n		flex: 1 1 0;\n\n		&:not(:last-child) a {\n			border-right: none;\n		}\n	}\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	display: flex;\n	width: 100%;\n	height: 100%;\n	background-color: #fff;\n	color: var(--emp-color);\n	cursor: pointer;\n	align-items: center;\n	justify-content: center;\n	border: 1px solid var(--line-color);\n	box-sizing: border-box;\n\n	",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	scroll-margin: 150px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: sticky;\n	top: 140px;\n	width: 100%;\n	border-bottom: 1px solid var(--line-color);\n	background-color: #fff;\n\n	ul {\n		display: flex;\n		height: 60px;\n		overflow-x: scroll;\n		-ms-overflow-style: none;\n		scrollbar-width: none;\n		&::-webkit-scrollbar {\n			display: none;\n		}\n\n		li:first-child {\n			a {\n				margin-left: 0;\n			}\n		}\n\n		li:last-child {\n			a {\n				margin-right: 0;\n			}\n		}\n	}\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	display: flex;\n	height: 100%;\n	margin: 0 15px;\n	color: var(--gray-color);\n	white-space: nowrap;\n	align-items: center;\n	justify-content: center;\n	flex-shrink: 0;\n	letter-spacing: -0.6px;\n\n	",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	height: 50vh;\n	scroll-margin: 200px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	height: 0;\n	max-width: 910px;\n	padding-top: 512px;\n	margin: 40px auto 0;\n\n	> div {\n		position: absolute;\n		top: 0;\n	}\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin-top: 40px;\n	text-align: center;\n\n	img {\n		height: auto;\n		max-width: 100%;\n		vertical-align: top;\n	}\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 20px 0;\n\n	img {\n		display: block;\n		width: 100%;\n		margin: 0 auto;\n		vertical-align: top;\n	}\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	position: relative;\n	overflow: hidden;\n	max-height: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n	margin: 60px 0 20px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}


var Wrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-0"
})(_templateObject());
var Content = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-1"
})(_templateObject1());
var TopNavi = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].ul.withConfig({
    componentId: "sc-81bc9b44-2"
})(_templateObject2());
var TopNaviItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
    componentId: "sc-81bc9b44-3"
})(_templateObject3(), function(props) {
    return props.isActive && "\n            border: 1px solid var(--emp-color);\n            border-right: 1px solid var(--emp-color) !important;\n            border-bottom-color: #fff;\n            background-color: #fff;\n			color: var(--emp-color);\n        ";
});
var ScrollTabList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].ul.withConfig({
    componentId: "sc-81bc9b44-4"
})(_templateObject4());
var ScrollTabItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
    componentId: "sc-81bc9b44-5"
})(_templateObject5(), function(props) {
    return props.isActive && "\n		border: none;\n		background-color: var(--emp-color);\n		color: #fff;\n	";
});
var ScrollContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-6"
})(_templateObject6());
var DayList = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-7"
})(_templateObject7());
var DayListItem = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].a.withConfig({
    componentId: "sc-81bc9b44-8"
})(_templateObject8(), function(props) {
    return props.isActive && '	\n			color: var(--emp-color);\n			 &:before {\n				 position: absolute;\n				 bottom: 0;\n				 left:0;\n				 width: 100%;\n				 height: 2px;\n				 background-color:var(--yellow-color);\n				 content: "";\n			 }\n		 ';
});
var ScheduleContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-9"
})(_templateObject9());
var PlayBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-10"
})(_templateObject10());
var ImgEditor = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-11"
})(_templateObject11());
var SurchargeBox = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-12"
})(_templateObject12());
var SubTitleWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-13"
})(_templateObject13());
var EditorWrap = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-14"
})(_templateObject14(), function(props) {
    return props.elementHeight;
});
var TabContent = styled_components__WEBPACK_IMPORTED_MODULE_2__["default"].div.withConfig({
    componentId: "sc-81bc9b44-15"
})(_templateObject15());
var ContentTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__["default"])(_FRAMEWORK_ui_desktop_text__WEBPACK_IMPORTED_MODULE_1__/* .SubTitle */ .DK).withConfig({
    componentId: "sc-81bc9b44-16"
})(_templateObject16());



/***/ })

}]);